module.exports = __webpack_public_path__ + "img/beer_id-6.47b10262.png";